import React from "react";
import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import { useKeycloak } from "@react-keycloak/web";
import useReactSimpleMatchMedia from "react-simple-matchmedia";
import AppPreloader from "../components/preloader/AppPreloader";

export const ZorniContext = createContext();

export const useZorni = () => {
  const context = useContext(ZorniContext);
  if (!context) {
    throw new Error("useZorni must be used within an ZorniProvider");
  }
  return context;
};

export const setAuthTokens = ({ token, refreshToken }) => {
  Cookies.set("ZORNI_AUTH_TOKEN", token);
  Cookies.set("ZORNI_REFRESH_TOKEN", refreshToken);
};

export const getAuthTokens = () => {
  const encryptedToken = Cookies.get("ZORNI_AUTH_TOKEN");
  const encryptedRefreshToken = Cookies.get("ZORNI_REFRESH_TOKEN");

  return {
    token: encryptedToken,
    refreshToken: encryptedRefreshToken,
  };
};

export const ZorniProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const [isAuthenticated, setAuthenticated] = useState();
  const [loading, setLoading] = useState(true); // Ajout de l'état de chargement
  const [userId, setUserId] = useState(null);
  const [firstConnection, setFirstConnection] = useState(false);
  const [email, setEmail] = useState(null);
  const [isOwner, setIsOwner] = useState(null);
  const [type, setType] = useState(null);
  const storedTokens = getAuthTokens();
  const token = storedTokens?.token || keycloak?.token || null;

  const triggerUserCreation = () => {
    setFirstConnection(false);
  };

  useEffect(() => {
    if (!initialized) {
      // Keycloak is still initializing, handle accordingly
      // Set loading to true
      setLoading(true);
      return;
    }
    // Keycloak is initialized, set loading to false and set authentication state
    setLoading(false);
    if (typeof token === "string" && token.split(".").length === 3) {
      try {
        const decoded = jwt_decode(token);
        if (decoded && decoded.sub && decoded.email && decoded.type) {
          setUserId(decoded.sub);
          setFirstConnection(decoded.firstConnection);
          setEmail(decoded.email);
          setIsOwner(decoded.owner);
          setType(decoded.type);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    } else {
      setUserId(null);
      setEmail(null);
      setIsOwner(null);
      setType(null);
    }
    setAuthenticated(keycloak.authenticated);
  }, [keycloak, initialized, token]);

  const isMobile = useReactSimpleMatchMedia("(max-width: 767px)");

  return (
    <ZorniContext.Provider
      value={{
        keycloak,
        isAuthenticated,
        isMobile,
        userId,
        firstConnection,
        email,
        type,
        isOwner,
        setAuthTokens,
        getAuthTokens,
        triggerUserCreation,
        accessToken: token,
      }}
    >
      {/* Portail ou back-office selon la route : voir AppPreloader. */}
      {loading ? <AppPreloader /> : children}
    </ZorniContext.Provider>
  );
};
